import { useBeat, useExternalRef } from "@kosmod/kit";
import { Component, h, Ref, useEffect } from "@lukekaalim/act";
import { a3, PropsFromClass } from "@lukekaalim/act-three";

import * as three from 'three';
import { Graphics3DSetup, renderBeat } from "../../core";

export type OrbitCameraProps = {
  ref?: Ref<three.PerspectiveCamera | null>,
  position?: three.Vector3Like,
  
  fixedRotationAngle?: number,
} & PropsFromClass<three.PerspectiveCamera>;

export const OrbitCamera: Component<OrbitCameraProps> = ({
  ref: externalRef,
  position = { x: 3.5, y: 1, z: 3.5 },
  fixedRotationAngle,
  ...props
}) => {
  const ref = useExternalRef(externalRef, null);
  const onRender = useBeat(renderBeat);

  useEffect(() => {
    const camera = ref.get();
    if (!camera)
      return;
    
    if (typeof fixedRotationAngle === 'number') {
      const x = Math.sin(fixedRotationAngle) * position.x;
      const z = Math.cos(fixedRotationAngle) * position.z;

      camera.position.x = x;
      camera.position.z = z;

      camera.lookAt(new three.Vector3())
      return
    }

    onRender(now => {
      const x = Math.sin(now / 1000 / 10) * position.x;
      const z = Math.cos(now / 1000 / 10) * position.z;

      camera.position.x = x;
      camera.position.z = z;

      camera.lookAt(new three.Vector3())
    });

  }, [position, fixedRotationAngle]);

  return h(a3.perspectiveCamera, {
    aspect: 9/16,
    ...props,
    ref,
    position: { x: 0, y: position.y, z: 0 }
  })
}